import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";

import Layout from "@/components/Layout";
import Product from "@/components/Product";

const ProductPage = (): React.ReactElement => {
  const router = useRouter();
  const { slug } = router.query;

  return (
    <Layout>
      <Product slug={slug} />
    </Layout>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default ProductPage;
